import React, { Component } from 'react'
import { connect } from 'react-redux'
import preload from 'components/enhancer/preload'
import { actions } from './redux'
import composeHOC from 'shared/utils/composeHOC'
import { Link } from 'react-router'

class Announcement extends Component {
  constructor(props) {
    super(props)
    this.needLeftNavigation = false
  }
  state = {
  }
  componentDidMount(){
    /* <div className="newsDetail content-width newsDetailCon clearfix">
      <div className="newsCon" style={{width: '100%'}}>
        <div className="newsTitle">
          <h1 className="newsTitle-text">{news && news.title}</h1>
        </div>
        <br></br>
        <div dangerouslySetInnerHTML={{__html: news && news.content}}>
        </div>
      </div>
    </div> */
  }
  render() {
    const {news} = this.props
    return(
      <div className="newsDetail rightCon  newsDetailCon clearfix">
        <div className="newsCon" style={{borderRight: 'none'}}>
          <div className="newsTitle">
            <h1 className="newsTitle-text">{news && news.title}</h1>
          </div>
          <br></br>
          <div dangerouslySetInnerHTML={{__html: news && news.content}}>
          </div>
          <br></br><br></br><br></br>
        </div>
      </div>
    )
  }
}


export default composeHOC(
  connect(state => ({
    news: state.aboutUs.news
  }), {
  }),
  preload(({dispatch}) => {
    return Promise.all([
      dispatch(actions.getNewsDetail(94))
    ])
  })
)(Announcement)



// WEBPACK FOOTER //
// ./modules/aboutUs/Announcement.js